import React, { useEffect, useState, useRef, useCallback } from "react";
import { connect } from "react-redux";
import {
  Form,
  Select,
  DatePicker,
  Button,
  Radio,
  Collapse,
  Modal,
  notification
} from "antd";
import {
  DeleteOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { v4 as uuidv4 } from "uuid"
import httpClient from "api/module/httpClient";
import { actions as SponsorsDashboardActions } from "redux/actions/dashboard-sponsors-actions";

import { searchUser } from "redux/actions/home-actions";
import { INTERNAL_LINKS } from "enum";
import {
    InputBlog,
    ImageUploadPersonalized,
    CustomInput, 
    CustomRadio,
    CustomButton
} from "../../../../components";
import moment from "moment";
import {TableTest} from "./tableSpecial"
import {getImagesCarg} from "redux/actions/blog-post-action";
import "./style.scss";

const { Option } = Select;

const ModalFormDashboardSponsors = ({
    searchUser,
    // addSponsorsDashboard,
    updateSponsorsDashboard,
    id,
    reduceMembers,
    getImagesCarg,
    title,
    notifyRe=()=>{},
    visible=()=>{},
    finish=()=>{},
}) => {
    const [sponsorDashboardDForm] = Form.useForm();
    const [showLink, setShowLink] = useState(false);
    const [funcBodyInput, setFuncBodyInput] = useState({});
    const [funcBodyInput2, setFuncBodyInput2] = useState({});
    const [searchUsers, setSearchUsers] = useState([]);
    const funcBodyInputDeliver = useRef({});
    const orderDelivers = useRef([]);
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(false)
    const [idDashboard, setIdDashboard] = useState(-1);
    const [descriptions, setDescriptions] = useState({des1:'',des2:''});
    const [cases, setCases] = useState('Dashboard Members')
    const [neData, setNeData] = useState({})
    const [bulModal, setBulModal] = useState(false)
    const [type, setType] = useState('')
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [codeD, setCodeD] = useState(-1);
    let clock = useRef(null);

    useEffect(() => {
        if(Object.keys(neData).length > 0){
            if(clock.current){clearTimeout(clock.current)}
            clock.current = setTimeout(() => {
                let objectInfo = {};
                setSearchUsers(((neData || {}).SponsorsDashboardsMembers || []).map(e => e.User))
                setMembers(((neData || {}).SponsorsDashboardsMembers || []).map(e => ({
                    value: e.User.id, 
                    label:`${e.User.firstName} / ${e.User.email}`
                })));
                if(cases === 'Samples and Templates'){
                    objectInfo = {templates: ((neData || {}).templates || [])}
                }
                if(cases === 'Deliverables'){
                    let deliversObject = ((neData || {}).deliverables || []).reduce((acc, obj) => {
                        acc[obj.idOrder] = {
                            ...obj,
                            approvers: (obj || {}).approvers || [],
                            expectedReadyDate: moment((obj || {}).expectedReadyDate).utc(),
                            expectedReviewDate: moment((obj || {}).expectedReviewDate).utc(),
                            expectedDeliverDate: moment((obj || {}).expectedDeliverDate).utc(),
                        }; 
                        return acc;
                    }, {}); 
                    
                    let deliverables = ((neData || {}).order || []).map((e,index) => {
                        return {...deliversObject[Number(e)],idOrder: index};
                    });
                    setDescriptionDeliverables(deliverables)
                    
                    objectInfo = {deliverables: (deliverables || []),}
                }
                if(cases === 'Additional Resources'){
                    setDescriptions({...descriptions, des2:(neData || {}).aditionalResources})
                }
                if(cases === 'Onboarding'){
                    setDescriptions({...descriptions, des1:(neData || {}).description})
                    objectInfo = {checkList: (neData || {}).checkList}
                }
                if(cases === 'Dashboard Members'){
                    objectInfo = {partnersName: (neData || {}).partnersName, members: (neData || {}).members}
                }
    
                sponsorDashboardDForm.setFieldsValue(objectInfo)
    
            }, 1000);
        }
    },[cases,neData])

    const setDashboard = async (datas,cafes) => {
        setCases(cafes);
        setNeData(datas)
    }

    useEffect(() => {
        visible({
            modal: (bul) => setBulModal(bul),
            set: (data,casess) => setDashboard(data,casess),            
        })
    },[])

    const resetAll = () => {
        setShowLink(false);
        setLoading(false);
        setBulModal(false);
        funcBodyInputDeliver.current = {};
        orderDelivers.current = [];
        setMembers([])
    }

    const handleSponsorDashboard = async (data) => {
        let description1 = {};
        let description2 = {};
        let templatesDash = {};
        let membersDashboard = {};
        let deliverablesDash = {};
        let images = {}
        if (funcBodyInput && cases === 'Onboarding') {
            description1 = funcBodyInput.data();
            images = {...images, ...(description1 || {}).images}
            description1 = {
                description: description1.body, 
                dashboardEdit: true,
                checkList: data.checkList
            };
        }
        if (funcBodyInput2 && cases === 'Additional Resources') {
            description2 = funcBodyInput2.data();
            images = {...images, ...(description1 || {}).images}
            description2 = {
                aditionalResources: description2.body, 
                dashboardEdit: true,
            };
        }
        if (cases === 'Dashboard Members') {
            membersDashboard = {
                partnersName: data?.partnersName,
                members: data?.members,
                dashboardEdit: true,
            };
        }
        if(cases === 'Deliverables'){
            deliverablesDash = {
                dashboardEdit: true,
                order: orderDelivers.current,
                deliverables: ((data || {}).deliverables || []).map((e,index) => {
                    let description = null;
                    if (funcBodyInputDeliver.current[index]) {
                        description = funcBodyInputDeliver.current[index].data();
                        images = {...images, ...(description || {}).images}
                        description = description.body;
                    }
                    return {
                        ...e,
                        expectedReadyDate: moment.utc(((e || {}).expectedReadyDate || {format:()=>{}}).format("YYYY-MM-DD HH:mm")).format(),
                        expectedReviewDate: moment.utc(((e || {}).expectedReviewDate || {format:()=>{}}).format("YYYY-MM-DD HH:mm")).format(),
                        expectedDeliverDate: moment.utc(((e || {}).expectedDeliverDate || {format:()=>{}}).format("YYYY-MM-DD HH:mm")).format(),
                        description,
                    }
                })
            }
        }
        if(cases === 'Samples and Templates'){
            templatesDash = {
                templates: data.templates
            }
        }

        let newData = {
            ...description1,
            ...description2,
            ...membersDashboard,
            ...deliverablesDash,
            ...templatesDash,
        }

        if(Number(id) !== -1){
            setLoading(true)
            let response = await httpClient.post(`private/blogpostCargImages`, images);
            let imgh = response.data.images;
            if (funcBodyInput && cases === 'Onboarding') {
                const responseHTML1 = funcBodyInput.functionReplaceImage(imgh)
                newData = {
                    ...newData,
                    description: responseHTML1, 
                };
            }
            if (funcBodyInput2 && cases === 'Additional Resources') {
                const responseHTML2 = funcBodyInput2.functionReplaceImage(imgh)
                newData = {
                    ...newData,
                    aditionalResources: responseHTML2, 
                };
            }
            if(cases === 'Deliverables'){
                newData = {
                    ...newData,
                    deliverables: ((newData || {}).deliverables || []).map((es,index) => {
                        let description = null;
                        if (funcBodyInputDeliver.current[index]) {
                            description = funcBodyInputDeliver.current[index].functionReplaceImage(imgh);
                            console.log("//////////finish",description)
                        }
                        return {
                            ...es,
                            description,
                        }
                    })
                }
            }
            updateSponsorsDashboard({...newData, id: Number(id)}, () => {
                finish(cases);
                resetAll();
            });
        }
    }

    const handleSearchSpeakers = (data) => {
        setType(data)
        if (data !== "") {
            searchUser(data,(userS) => {
                setSearchUsers(userS)
            });
        }
    };

    const setDescriptionDeliverables = (del,num=0) => {
        console.log(funcBodyInputDeliver.current)
        if(funcBodyInputDeliver.current[0] && (funcBodyInputDeliver.current[0] || {}).functionValueDefault){
            del.map((ass,index) => {
                const containerMap = document.createElement("div");
                containerMap.innerHTML = ((ass || {}).description || '');
                let data = ((containerMap || {}).children || [])[0]
                    ? (((containerMap || {}).children || [])[0] || {}).innerHTML
                    : "";
                funcBodyInputDeliver.current[index].functionValueDefault(data);    
            })
        }else{
            num = num + 1; 
            setTimeout(() => {
                setDescriptionDeliverables(del,num)
            }, 200);
        }
    } 

    useEffect(() => {
        if (funcBodyInput !== undefined && descriptions.des1) {
            if (typeof funcBodyInput.data === "function") {
              const containerMap = document.createElement("div");
              containerMap.innerHTML = descriptions.des1;
              let data = containerMap.children[0]
                ? containerMap.children[0].innerHTML
                : "";
              funcBodyInput.functionValueDefault(data);
            }
        }
    },[funcBodyInput,descriptions])

    useEffect(() => {
        if (funcBodyInput2 !== undefined && descriptions.des2) {
            if (typeof funcBodyInput2.data === "function") {
              const containerMap = document.createElement("div");
              containerMap.innerHTML = descriptions.des2;
              let data = containerMap.children[0]
                ? containerMap.children[0].innerHTML
                : "";
              funcBodyInput2.functionValueDefault(data);
            }
        }
    },[funcBodyInput2,descriptions])

    const clickCollapse = (e) => {
        let content = e.currentTarget.nextElementSibling;
        if(content){
            let bule = content.getAttribute('data-info');
            content.style.cssText = bule === 'true'
                ? "position:absolute; height:0px; padding: 0px 18px; transform: scale(0);"
                : "position:relative; height:auto; padding: 10px 18px; transform: scale(1);";
            content.setAttribute('data-info', bule === 'true' ? 'false' : 'true');
        }
    }

    useEffect(() => {
        setCodeD(uuidv4())
    },[])

    const dataSourceColumns = [
        {
          title: "",
          dataIndex: "body",
          key: "body",
          render: (data={}) => {
            let {field={}, remove=()=>{}, index=-1} = data
            return <>
                <button type="button" id="collapsible-dash" onClick={(e) => clickCollapse(e)}>
                    <div style={{ height: "20px", display: "flex", flexDirection:"row", alignItems:'center' }}>
                        <p style={{ margin:"0px", marginLeft: "5px" }}>Deliverable {index + 1}</p>
                        <DeleteOutlined
                            onClick={() => {
                                orderDelivers.current = orderDelivers.current.filter(e => Number(e) !== Number(field.fieldKey))
                                remove(field.name);
                            }}
                            style={{position: "absolute",right: "40px"}}
                        />
                    </div>
                </button>
                <div className="content-dash" style={{overflow:'visible'}}>
                    <div style={{width: "100%",position: "relative",display: "flex",flexDirection: "column", overflow:'visible'}}>
                        <Form.Item
                            {...field}
                            key={`idOrder-${index}`}
                            label="idOrder"
                            name={[field.name, "idOrder"]}
                            style={{position:'absolute',opacity:'0',left:'-10000px'}}
                        >
                            <CustomInput/>
                        </Form.Item>
                        <Form.Item
                            {...field}
                            key={`name-${index}`}
                            label="Name"
                            name={[field.name, "name"]}
                        >
                            <CustomInput/>
                        </Form.Item>
                        <Form.Item
                            {...field}
                            key={`type-${index}`}
                            label="Type"
                            name={[field.name, "type"]}
                            rules={[{ required: true, message: "Deliverables Type is required." }]}
                        >
                            <Select style={{ width: "500px" }}>
                                <Select.Option key={'Single Image'} value={'Single Image'}>
                                    Single Image
                                </Select.Option>
                                <Select.Option key={'Carousel'} value={'Carousel'}>
                                    Carousel
                                </Select.Option>
                                <Select.Option key={'Video'} value={'Video'}>
                                    Video
                                </Select.Option>
                                <Select.Option key={'Linkedin Newsletter'} value={'Linkedin Newsletter'}>
                                    Linkedin Newsletter
                                </Select.Option>
                                <Select.Option key={'Other'} value={'Other'}>
                                    Other
                                </Select.Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            {...field}
                            key={`design-${index}`}
                            label="Design"
                            name={[field.name, "design"]}
                            rules={[{ required: true, message: "Deliverables Type is required." }]}
                        >
                            <Radio.Group className="d-flex flex-column session-form-radiogrp">
                                <CustomRadio
                                    value={"Co-branded"}
                                    style={{ marginTop: "20px" }}
                                >
                                    Co-branded
                                </CustomRadio>
                                <CustomRadio
                                    value={"Branded"}
                                    style={{ marginTop: "20px" }}
                                >
                                    Branded
                                </CustomRadio>
                            </Radio.Group>
                        </Form.Item>

                        <Form.Item
                            {...field}
                            key={`expectedReadyDate-${index}`}
                            name={[field.name, "expectedReadyDate"]}
                            label="Expected Ready Date"
                            rules={[
                                {required: true,message: "Date is required."},
                            ]}
                        >
                            <DatePicker
                                format="YYYY-MM-DD"
                                showTime={true}
                                style={{ width: "100%" }}
                            />
                        </Form.Item>

                        <Form.Item
                            {...field}
                            key={`expectedReviewDate-${index}`}
                            name={[field.name, "expectedReviewDate"]}
                            label="Expected Review Date"
                            rules={[
                                {required: true,message: "Date is required."},
                            ]}
                        >
                            <DatePicker
                                format="YYYY-MM-DD"
                                showTime={true}
                                style={{ width: "100%" }}
                            />
                        </Form.Item>

                        <Form.Item
                            {...field}
                            key={`expectedDeliverDate-${index}`}
                            name={[field.name, "expectedDeliverDate"]}
                            label="Expected Deliver Date"
                            rules={[
                                {required: true,message: "Date is required."},
                            ]}
                        >
                            <DatePicker
                                format="YYYY-MM-DD"
                                showTime={true}
                                style={{ width: "100%" }}
                            />
                        </Form.Item>

                        <Form.Item
                            {...field}
                            key={`description-${index}`}
                            name={[field.name, "description"]}
                            label="Description"
                        >
                            <InputBlog index={field.fieldKey} uniqueGroup={codeD} functionData={(e) => {
                                funcBodyInputDeliver.current = {
                                    ...funcBodyInputDeliver.current,
                                    [index]: e
                                }
                            }} />
                        </Form.Item>

                        <Form.Item
                            {...field}
                            key={`approvers-${index}`}
                            name={[field.name, "approvers"]}
                            label="Approver"
                            rules={[
                                {required: true,message: "Approver is required."},
                            ]}
                        >
                            <Select
                                mode="multiple"
                                placeholder="Certificate Programs"
                                style={{ width: "100%",marginTop: "1rem" }}
                            >
                                {(members || []).map((users) => {
                                    return (
                                    <Option key={users.value} value={users.value}>
                                        {users.label}
                                    </Option>
                                    );
                                })}
                            </Select>
                        </Form.Item>

                        <Form.Item 
                            {...field}
                            key={`relevantLinks-${index}`}
                            name={[field.name, "relevantLinks"]}
                            label="Relevant Links"
                        >
                            <Select mode="tags"></Select>
                        </Form.Item>
                    </div>
                </div>
            </>
          }
        },
    ];

    const dataSortFixed = (fields, remove) => {
        let ids = [];
        let newFields = fields.map((field,index) => {
            ids = [...ids,field.fieldKey]
            return {body: {field, index, remove},id:field.fieldKey};
        }).reduce((acc, obj) => { acc[obj.id] = obj; return acc;}, {});
        ids = ids.filter(e => !(orderDelivers.current || []).includes(e));
        let data = [...(orderDelivers.current || []),...ids].map(e => {
            return newFields[e];
        });
        orderDelivers.current = [...(orderDelivers.current || []),...ids];
        return data;
    }

    useEffect(() => {
        console.log(searchUsers)
    },[searchUsers])

    return (
        <Modal
            className="modal-special-deliverables"
            width={"1080px"}
            footer={null}
            style={{ height: "auto", top: "0px" }}
            visible={bulModal !== false}
            onCancel={() => setBulModal(false)}
        >
            <div className="container-dashboard-sponsor">
                <Form
                    layout="vertical"
                    form={sponsorDashboardDForm}
                    onFinish={(data) => handleSponsorDashboard(data)}
                    style={{paddingTop: '40px', maxWidth: '750px', width: '750px'}}
                >

                    {cases === 'Dashboard Members' && <>
                        <Form.Item
                            label="Partners Name"
                            name="partnersName"
                            rules={[{ required: true, message: "Partners Name is required." }]}
                        >
                            <CustomInput />
                        </Form.Item>

                        <Form.Item
                            label="Members"
                            name="members"
                            required={false}
                        >
                            <Select
                                style={{ width: "100%" }}
                                mode="multiple"
                                onKeyUp={(e) => {handleSearchSpeakers(e.target.value)}}
                                optionFilterProp="children"
                                onChange={(_,data) => {
                                    setMembers(data.map(e => ({label: e.children,value: e.value})));
                                }}
                            >
                                {searchUsers !== undefined ? (
                                    [...searchUsers,{id:type,firstName:'',email:'USER DOES NOT EXIST'}].map((users) => {
                                        let bul1 = (searchUsers.length === 0 && users.email === 'USER DOES NOT EXIST')
                                        return (bul1) || (searchUsers.length > 0 && users.email !== 'USER DOES NOT EXIST') ? (
                                            <Option key={users.id} value={users.id} disabled={bul1}>
                                                {bul1 
                                                    ? `${users.id} / USER DOES NOT EXIST` 
                                                    : `${users.firstName} / ${users.email}`}
                                            </Option>
                                        ) : <></>;
                                    })
                                ) : (
                                    <div></div>
                                )}
                            </Select>
                        </Form.Item>
                        {(type !== '' && searchUsers.length === 0) && <div className="container-input-modal-edit">
                            <div className="container-division-modal-edit">
                                <div className="column-input-dashboard">
                                    <p className="label-input-dashboard">Email</p>
                                    <CustomInput value={type} onChange={(d) => {setType(d)}} />
                                </div>
                                <div className="column-input-dashboard">
                                    <p className="label-input-dashboard">First Name</p>
                                    <CustomInput value={firstName} onChange={(e) => {setFirstName(e)}} />
                                </div>
                                <div className="column-input-dashboard">
                                    <p className="label-input-dashboard">Last Name</p>
                                    <CustomInput value={lastName} onChange={(e) => {setLastName(e)}} />
                                </div>
                            </div>
                            <div className="container-division-modal-edit">
                                <CustomButton
                                    onClick={() => {
                                        notifyRe(
                                            {
                                              emails: Object.values(reduceMembers || [])?.filter(f => f.role === 'admin')?.map(f => f.email),
                                              email: type,
                                              firstName: firstName,
                                              lastName: lastName,
                                              contentNotification: title,
                                            },
                                            'notificationToUserSRegistration',
                                            () => {
                                                setType('');
                                                setFirstName('');
                                                setLastName('');
                                                notification.info({
                                                  message: "Email sent and active follow-up control",
                                                });
                                            }
                                        )
                                    }}
                                    text="Create Invitation"
                                />
                            </div>
                        </div>}
                    </>}

                    {cases === 'Onboarding' && <><Form.Item
                        label="Message + Description"
                        name="description"
                    >
                        <InputBlog functionData={(e) => setFuncBodyInput(e)} />
                    </Form.Item>

                    <Form.Item label="Checklist" name="checkList">
                        <Select mode="tags"></Select>
                    </Form.Item></>}

                    {cases === 'Additional Resources' && <Form.Item
                        label="Additional Resources"
                        name="aditionalResources"
                    >
                        <InputBlog functionData={(e) => setFuncBodyInput2(e)} />
                    </Form.Item>}

                    {cases === 'Deliverables' && <Form.List name="deliverables">
                        {(fields, { add, remove }) => (
                            <>
                                <TableTest
                                    data={dataSortFixed(fields, remove)}
                                    columns={dataSourceColumns}
                                    onChange={(data) => {
                                        orderDelivers.current = data;
                                    }}
                                ></TableTest> 
                                <Form.Item>
                                    <Button
                                        type="dashed"
                                        onClick={() => {
                                            add({ idOrder: fields.length }); 
                                        }}
                                        block
                                        icon={<PlusOutlined />}
                                    >
                                        New Deliverables
                                    </Button>
                                </Form.Item>
                            </>
                        )}
                    </Form.List>}

                    {cases === 'Samples and Templates' && <Form.List name="templates">
                        {(fields, { add, remove }) => (
                            <>
                            <Collapse>
                                {fields.map((field, index) => (
                                <Collapse.Panel
                                    header={
                                        <div style={{ height: "20px" }}>
                                            <p>Template {index + 1}</p>
                                            <DeleteOutlined
                                                onClick={() => {remove(field.name);}}
                                                style={{position: "absolute",top: "15px",right: "20px"}}
                                            />
                                        </div>
                                    }
                                    key={field.key}
                                >
                                    <div style={{width: "100%",position: "relative",display: "flex",flexDirection: "column"}}>
                                        <Form.Item
                                            {...field}
                                            key={`image-${index}`}
                                            name={[field.name, "image"]}
                                            label="Image"
                                            rules={[
                                                {required: true,message: "Image is required."},
                                            ]}
                                        >
                                            <ImageUploadPersonalized aspect={600 / 600} textScale="600 * 600 px"  />                   
                                        </Form.Item>
                                        <Form.Item
                                            {...field}
                                            key={`title-${index}`}
                                            name={[field.name, "title"]}
                                            label="Title"
                                            rules={[
                                                {required: true,message: "Title is required."},
                                            ]}
                                        >
                                            <CustomInput />
                                        </Form.Item>
                                        <Form.Item
                                        {...field}
                                        key={`link-${index}`}
                                        name={[field.name, "link"]}
                                        label="Link"
                                        rules={[
                                            {required: true,message: "Link is required."},
                                        ]}
                                        >
                                            <CustomInput />
                                        </Form.Item>
                                    </div>
                                </Collapse.Panel>
                                ))}
                            </Collapse>
                            <Form.Item>
                                <Button
                                    type="dashed"
                                    onClick={() => add()}
                                    block
                                    icon={<PlusOutlined />}
                                >
                                    New Templates
                                </Button>
                            </Form.Item>
                            </>
                        )}
                    </Form.List>}

                    <Form.Item>
                        <div style={{display:'flex',justifyContent:'center',alignItems:'center',width:'100%'}}>
                            <CustomButton
                                loading={loading}
                                onClick={() => sponsorDashboardDForm.submit()}
                                text={`Save`}
                            />
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = {
  searchUser,
  getImagesCarg,
  ...SponsorsDashboardActions
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalFormDashboardSponsors);